export var RelativePerformanceLookbackPeriod;
(function (RelativePerformanceLookbackPeriod) {
    RelativePerformanceLookbackPeriod["7b"] = "7";
    RelativePerformanceLookbackPeriod["14b"] = "14";
    RelativePerformanceLookbackPeriod["30b"] = "30";
    RelativePerformanceLookbackPeriod["60b"] = "60";
    RelativePerformanceLookbackPeriod["90b"] = "90";
})(RelativePerformanceLookbackPeriod || (RelativePerformanceLookbackPeriod = {}));
export var BarRelativePerformanceState;
(function (BarRelativePerformanceState) {
    BarRelativePerformanceState["overperforming"] = "overperforming";
    BarRelativePerformanceState["underperforming"] = "underperforming";
    BarRelativePerformanceState["neutral"] = "neutral";
})(BarRelativePerformanceState || (BarRelativePerformanceState = {}));
export var BarRelativePerformanceColorState;
(function (BarRelativePerformanceColorState) {
    BarRelativePerformanceColorState["bothRed"] = "bothRed";
    BarRelativePerformanceColorState["bothGreen"] = "bothGreen";
    BarRelativePerformanceColorState["aRedBGreen"] = "aRedBGreen";
    BarRelativePerformanceColorState["aGreenBRed"] = "aGreenBRed";
})(BarRelativePerformanceColorState || (BarRelativePerformanceColorState = {}));
export var AnchoredRelativePerformanceState;
(function (AnchoredRelativePerformanceState) {
    AnchoredRelativePerformanceState["overperforming"] = "overperforming";
    AnchoredRelativePerformanceState["underperforming"] = "underperforming";
    AnchoredRelativePerformanceState["neutral"] = "neutral";
    AnchoredRelativePerformanceState["notEnoughData"] = "notEnoughData";
})(AnchoredRelativePerformanceState || (AnchoredRelativePerformanceState = {}));
export var BarRelativePerformanceEventType;
(function (BarRelativePerformanceEventType) {
    BarRelativePerformanceEventType["flip"] = "flip";
})(BarRelativePerformanceEventType || (BarRelativePerformanceEventType = {}));
export var RelativePerformanceFlipType;
(function (RelativePerformanceFlipType) {
    RelativePerformanceFlipType["flipToOverperforming"] = "flipToOverperforming";
    RelativePerformanceFlipType["flipToUnderperforming"] = "flipToUnderperforming";
    RelativePerformanceFlipType["flipToNeutral"] = "flipToNeutral";
})(RelativePerformanceFlipType || (RelativePerformanceFlipType = {}));
export var AnchoredRelativePerformanceEventType;
(function (AnchoredRelativePerformanceEventType) {
    AnchoredRelativePerformanceEventType["crossover"] = "crossover";
    AnchoredRelativePerformanceEventType["flip"] = "flip";
    AnchoredRelativePerformanceEventType["newHighLow"] = "newHighLow";
})(AnchoredRelativePerformanceEventType || (AnchoredRelativePerformanceEventType = {}));
export var CrossoverType;
(function (CrossoverType) {
    CrossoverType["upcross"] = "upcross";
    CrossoverType["downcross"] = "downcross";
})(CrossoverType || (CrossoverType = {}));
export var AnchoredRelativePerformanceRelativeStateType;
(function (AnchoredRelativePerformanceRelativeStateType) {
    AnchoredRelativePerformanceRelativeStateType["period1AbovePeriod2"] = "period1AbovePeriod2";
    AnchoredRelativePerformanceRelativeStateType["period1BelowPeriod2"] = "period1BelowPeriod2";
    AnchoredRelativePerformanceRelativeStateType["neutral"] = "neutral";
})(AnchoredRelativePerformanceRelativeStateType || (AnchoredRelativePerformanceRelativeStateType = {}));
//# sourceMappingURL=RelativePerformance.js.map